var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "@patternfly/react-core/dist/styles/base.css";
// import "@patternfly/patternfly/patternfly.css";
// edit file
import "./css/app.css";
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import "./Components/webcomponents/AppLayoutPage";
export let MainApp = class MainApp extends LitElement {
    render() {
        return html ` <app-layout></app-layout>`;
    }
};
MainApp.styles = css `
    /* Your component's styles here */
    :host {
      display: block;
    }
  `;
MainApp = __decorate([
    customElement("main-app")
], MainApp);
